import React from 'react'

export interface ChipsTabsContextValue {
  currentValue: string | number
  onChange: (value: string | number) => void
}

export const ChipsTabsContext = React.createContext<ChipsTabsContextValue | null>(null)

export function useChipsTabsContext(): ChipsTabsContextValue {
  const ctx = React.useContext(ChipsTabsContext)
  if (!ctx) throw new Error('useChipsTabsContext must be used inside ChipsTabs')
  return ctx
}
